import Input from "@/app/components/ui/Inputs/Input";
import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { useForm } from "react-hook-form";

interface IAskAIFormFields {
  query: string;
}

const AskAIModal = () => {
  const formHook = useForm<IAskAIFormFields>({
    mode: "onChange",
  });
  const onSubmit = () => {};
  return (
    <ModalPrompt
      modalId="ASK_AI_MODAL"
      backdropBlur={true}
      content={
        <div className="w-full">
          <form className="w-full" onSubmit={formHook.handleSubmit(onSubmit)}>
            <Input
              errorMessages={[{ type: "required", message: "Enter a prompt" }]}
              fieldError={formHook.formState.errors.query}
              register={formHook.register("query")}
              placeholder="Enter a prompt"
              className="w-full"
              inputClassName="w-full"
              startIcon={
                <span className="flex justify-start items-center text-xs">
                  <span>✨</span> <span>Ask</span>
                </span>
              }
            />
          </form>
        </div>
      }
    />
  );
};

export default AskAIModal;
